import { createContext } from "react";

export const SelectedElementContex = createContext();